import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getSecondWeightEntryList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getSecondWeightEntryListByDieId = (dieId, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/', {
    
        
        headers: authHeader(), params: {
            die: dieId,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getArchiveSecondWeightEntryList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getSecondWeightEntryDetails = (dieId) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool-details/', {
        headers: authHeader(), params: {
            die: dieId
        }
    });
};


const getSecondWeightEntryById = (id) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/', {
        headers: authHeader(), params: {
            id: id
        }
    });
};
const addSecondWeightEntry = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/`,
        formData, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const updateSecondWeightEntry = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const deleteSecondWeightEntry = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveSecondWeightEntryRecord = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const secondWeightEntryService = {
    getSecondWeightEntryList,
    getSecondWeightEntryListByDieId,
    getArchiveSecondWeightEntryList,
    getSecondWeightEntryDetails,
    getSecondWeightEntryById,
    addSecondWeightEntry,
    updateSecondWeightEntry,
    deleteSecondWeightEntry,
    unArchiveSecondWeightEntryRecord
};

export default secondWeightEntryService;
